exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb-message-detail .el-dialog__header .el-dialog__title{\r\n  color: #8B8B8E;\n}\n.mb-message-detail .el-dialog__body .content{\r\n  color: #161616;\r\n  margin-bottom: 20px;\n}\n.mb-message-detail .el-dialog__body .date{\r\n  color: #8B8B8E\n}\r\n", ""]);

// exports
